import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-agency-one-banner',
  templateUrl: './agency-one-banner.component.html',
  styleUrls: ['./agency-one-banner.component.scss']
})
export class AgencyOneBannerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}